import { RegisterTextEditor } from "./RegisterTextEditor";
import { TextElementEditor } from "../Editors/Text/TextElementEditor";
import { TextMergeBlockQuoteEditor } from "../Editors/Text/TextMergeBlockQuoteEditor";
import { TextMergeCodeEditor } from "../Editors/Text/TextMergeCodeEditor";
import { TextMergeFieldEditor } from "../Editors/Text/TextMergeFieldEditor";
import { TextMergeHorizontalLineEditor } from "../Editors/Text/TextMergeHorizontalLineEditor";
import { TextMergeStyleEditor } from "../Editors/Text/TextMergeStyleEditor";
import { TextMergeLineBreakEditor } from "../Editors/Text/TextMergeLineBreakEditor";
import { SubstitutionTextElementEditor } from "../Editors/SubstitutionTextElementEditor";
import { ConditionalElementEditor } from "../Editors/ConditionalElementEditor";
import { TextElement } from "../../rule-engine-core/TextMerge/Elements/Text/TextElement";
import { BlockQuoteElement } from "../../rule-engine-core/TextMerge/Elements/Text/BlockQuoteElement";
import { CodeElement } from "../../rule-engine-core/TextMerge/Elements/Text/CodeElement";
import { FieldElement } from "../../rule-engine-core/TextMerge/Elements/Text/FieldElement";
import { HorizontalLineElement } from "../../rule-engine-core/TextMerge/Elements/Text/HorizontalLineElement";
import { LineBreakElement } from "../../rule-engine-core/TextMerge/Elements/Text/LineBreakElement";
import { StyleElement } from "../../rule-engine-core/TextMerge/Elements/Text/StyleElement";
import { SubstitutionTextElement } from "../../rule-engine-core/TextMerge/Elements/SubstitutionTextElement";
import { ConditionalElement } from "../../rule-engine-core/TextMerge/Elements/ConditionalElement";
import { IterationTextMergeEditor } from "../Editors/IterationTextMergeEditor";
import { IterationTextMergeElement } from "../../rule-engine-core/TextMerge/Elements/IterationTextMergeElement";
import { JSONXMLStringEditor } from "../Editors/JSONXML/JSONXMLStringEditor";
import { JSONXMLNumberEditor } from "../Editors/JSONXML/JSONXMLNumberEditor";
import { JSONXMLStringElement } from "../../rule-engine-core/TextMerge/Elements/JSONXML/JSONXMLStringElement";
import { JSONXMLBooleanEditor } from "../Editors/JSONXML/JSONXMLBooleanEditor";
import { JSONXMLNumberElement } from "../../rule-engine-core/TextMerge/Elements/JSONXML/JSONXMLNumberElement";
import { JSONXMLDateEditor } from "../Editors/JSONXML/JSONXMLDateEditor";
import { JSONXMLObjectEditor } from "../Editors/JSONXML/JSONXMLObjectEditor";
import { JSONXMLObjectElement } from "../../rule-engine-core/TextMerge/Elements/JSONXML/JSONXMLObjectElement";
import { JSONXMLBuildObjectElement } from "../../rule-engine-core/TextMerge/Elements/JSONXML/JSONXMLBuildObjectElement";
import { JSONXMLBuildObjectEditor } from "../Editors/JSONXML/JSONXMLBuildObjectEditor";
import { JSONXMLDateElement } from "../../rule-engine-core/TextMerge/Elements/JSONXML/JSONXMLDateElement";
import { JSONXMLBooleanElement } from "../../rule-engine-core/TextMerge/Elements/JSONXML/JSONXMLBooleanElement";
import { XMLAttributeElement } from "../../rule-engine-core/TextMerge/Elements/JSONXML/XMLAttributeElement";
import { XMLAttributeEditor } from "../Editors/JSONXML/XMLAttributeEditor";

export class RegisterTextEditors {
    static registrationRun: boolean = false;

    static doRegistration() {
        if (this.registrationRun) return;

        this.registrationRun = true;

        RegisterTextEditor(new TextElementEditor(), new TextElement());
        RegisterTextEditor(new TextMergeBlockQuoteEditor(), new BlockQuoteElement());
        RegisterTextEditor(new TextMergeCodeEditor(), new CodeElement());
        RegisterTextEditor(new TextMergeFieldEditor(), new FieldElement());
        RegisterTextEditor(new TextMergeHorizontalLineEditor(), new HorizontalLineElement());
        RegisterTextEditor(new TextMergeLineBreakEditor(), new LineBreakElement());
        RegisterTextEditor(new TextMergeStyleEditor(), new StyleElement());
        RegisterTextEditor(new SubstitutionTextElementEditor(), new SubstitutionTextElement());
        RegisterTextEditor(new ConditionalElementEditor(), new ConditionalElement());
        RegisterTextEditor(new IterationTextMergeEditor(), new IterationTextMergeElement());

        RegisterTextEditor(new JSONXMLStringEditor(), new JSONXMLStringElement());
        RegisterTextEditor(new JSONXMLNumberEditor(), new JSONXMLNumberElement());
        RegisterTextEditor(new JSONXMLBooleanEditor(), new JSONXMLBooleanElement());
        RegisterTextEditor(new JSONXMLDateEditor(), new JSONXMLDateElement());
        RegisterTextEditor(new JSONXMLObjectEditor(), new JSONXMLObjectElement());
        RegisterTextEditor(new JSONXMLBuildObjectEditor(), new JSONXMLBuildObjectElement());
        RegisterTextEditor(new XMLAttributeEditor(), new XMLAttributeElement());
    }
}
